import * as React from "react"
import { batch } from "@preact/signals-react"
import {Box, Chip, Grid, Typography} from "@mui/material"
import { ModalSeeker } from "@ui-seeker/core"
import {isEmpty} from "@ui-seeker/utils"

import {ChipBlock, ListCountries, ListRetailers} from "./@components";
import {monitoringAdminReportDetails} from "./@signals";
import { DAYS_OF_WEEK, MONTHS } from "./constants";


const EmptyCell = ({ text='All selected' }) => <Typography variant="caption" color="textSecondary">
    {text}
</Typography>

export default function MonitoringAdminReportDetailsModals() {

    const {
        name = '',
        brands = [],
        sites = [],
        skus = [],
        countries = [],
        skuGroups = [],
        executions = {},
        zone = null
    } = monitoringAdminReportDetails.value || {};

    const controller = () => monitoringAdminReportDetails.value = {}

    return <ModalSeeker
        isOpen={!isEmpty(monitoringAdminReportDetails.value)}
        controller={controller}
        size="md"
        hideActions
        title='Execution Details'
    >
        <Grid container spacing={3}>

            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                        Execution Name:
                    </Typography>
                    {!!name ? name : <EmptyCell />}
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                        Time Zone:
                    </Typography>
                    {!!zone ? zone : <EmptyCell />}
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                        Execution Time:
                    </Typography>
                    {!isEmpty(executions) && executions['Time'].map((hours, index) => (
                        <Chip
                            label={new Date(hours).toLocaleTimeString()}
                            key={index}
                            sx={{ mr: 1, backgroundColor: "disabled.dark" }}
                        />
                    ))}
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                        Execution Months Days:
                    </Typography>
                    {!isEmpty(executions) && !executions["Months Days"]?.length && <Typography variant="body2">All</Typography>}
                    {!isEmpty(executions) && executions["Months Days"][0] !== "All" && executions['Months Days'].map((day, index) => (
                        <Chip
                            label={day}
                            key={index}
                            sx={{ mr: 1, mt: 1, backgroundColor: "disabled.dark" }}
                        />
                    ))}
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                        Execution Months:
                    </Typography>
                    {!isEmpty(executions) && !executions["Months"]?.length && <Typography variant="body2">All</Typography>}
                    {!isEmpty(executions) && executions["Months"][0] !== "All" && executions['Months'].map((month, index) => (
                        <Chip
                            label={MONTHS[month + 1]}
                            key={index}
                            sx={{ mr: 1, mt: 1, backgroundColor: "disabled.dark" }}
                        />
                    ))}
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                        Execution Months:
                    </Typography>
                    {!isEmpty(executions) && !executions["Week Days"]?.length && <Typography variant="body2">All</Typography>}
                    {!isEmpty(executions) && executions["Week Days"][0] !== "All" && executions['Week Days'].map((day, index) => (
                        <Chip
                            label={DAYS_OF_WEEK[day]}
                            key={index}
                            sx={{ mr: 1, mt: 1, backgroundColor: "disabled.dark" }}
                        />
                    ))}
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                        Countries:
                    </Typography>
                    {!!countries ? <ListCountries countries={countries} /> : <EmptyCell />}
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                        Retailers:
                    </Typography>
                    {!!sites ? <ListRetailers retailers={sites} /> : <EmptyCell />}
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                        Brands:
                    </Typography>
                    {!!brands ? <ChipBlock listElements={brands} /> : <EmptyCell />}
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                        Sku Groups:
                    </Typography>
                    {!!skuGroups ? <ChipBlock listElements={skuGroups} /> : <EmptyCell />}
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                        Skus:
                    </Typography>
                    {!!skus ? <ChipBlock listElements={skus} sx={{ maxHeight: 400, overflowY: 'auto' }}  /> : <EmptyCell />}
                </Box>
            </Grid>

        </Grid>

    </ModalSeeker>
}